import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import icon from '@assets/ic_info.svg';
import { Box, Paper, Typography } from '@mui/material';
import { COLORS } from '@constants/colors';
export const InfoBox = ({ title, items }) => {
    return (_jsx(Paper, { elevation: 0, sx: theme => ({
            bgcolor: theme.palette.infoBox.background,
            border: `1px solid ${theme.palette.infoBox.border}`,
            borderRadius: '4px',
            p: theme.spacing(2),
            boxShadow: COLORS.shadow.infoBox,
        }), children: _jsxs(Box, { sx: { display: 'flex', gap: 1.5, alignItems: 'flex-start' }, children: [_jsx(Box, { component: "img", src: icon, alt: "info icon", sx: {
                        height: 'auto',
                        width: 'auto',
                        maxHeight: '100%',
                        objectFit: 'contain',
                    } }), _jsxs(Box, { sx: { flex: 1 }, children: [_jsx(Typography, { variant: "body1", color: "textSecondary", children: title }), _jsx(Box, { component: "ul", sx: theme => ({
                                margin: 0,
                                paddingLeft: 2.5,
                                '& li': {
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    lineHeight: 1.5,
                                    color: theme.palette.text.secondary,
                                    '&:last-child': {
                                        marginBottom: 0,
                                    },
                                },
                            }), children: items.map((item, index) => (_jsx("li", { children: item }, index))) })] })] }) }));
};
